export const safeStorage = {
  has(key: string): boolean {
    try {
      return localStorage.getItem(key) !== null;
    } catch {
      return false;
    }
  },
  remember(key: string): void {
    try {
      localStorage.setItem(key, '1');
    } catch {
      return;
    }
  },
  readDraft(key: string): Record<string, unknown> | null {
    try {
      const stored = sessionStorage.getItem(key);
      const parsed: unknown = stored ? JSON.parse(stored) : null;
      return parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>) : null;
    } catch {
      return null;
    }
  },
  writeDraft(key: string, value: Record<string, unknown>): void {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      return;
    }
  },
  discardDraft(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch {
      return;
    }
  },
};
